import React, { createContext } from "react";
import type { Annotation } from "@/types/annotation";
import { Prediction } from "@/utils/api/inference";
import { FrameInferenceResult } from "@/types/inference";
import { FileInputDimensions } from "@/types/media";
export interface ComputedValues {
    allCurrentFrameAnnotations: Annotation[];
    currentFrameAnnotations: Annotation[];
    currentFrameUserAnnotations: Annotation[];
    currentFramePredictions: Prediction[];
    currentPromptingData: any[];
    currentInferenceSampledData: FrameInferenceResult[];
    selectedObject: string | null;
    inferredDimensions?: FileInputDimensions;
    allAnnotationsAcrossFiles: Annotation[];
    allPredictionsAcrossFiles: Prediction[];
    imagesNeededToDeploy: number;
    hasEnoughDataToDeploy: boolean;
}

export const ComputedValuesContext = createContext<ComputedValues | undefined>(undefined);

export function useComputedValues() {
    const ctx = React.useContext(ComputedValuesContext);
    if (!ctx) throw new Error("useComputedValues must be used within a ComputedValuesProvider");
    return ctx;
}
